var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('vue-form',{attrs:{"canvalidate":false,"name":'member-'+_vm.memberId,"fields":_vm.questions},on:{"change":_vm.updateInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }